import React from 'react';
import ReservationForm from './ReservationForm';
import {useParams} from "react-router-dom"

export default function EditReservation() {
  const { id } = useParams();
  return <ReservationForm id={Number(id)}/>;
}
